module.exports = __webpack_public_path__ + "static/media/60Hym.26055ac3.gif";